import style from "./index.module.scss";
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import BasicAnalytics from "../components/BasicAnalytics";
import AnalyticsByTransportType from "../components/AnalyticsByTransportType";
import { Analytics } from "../../../services";
import OrderCountByPeriod from "../components/OrderCountByPeriod";
import TopDirections from "../components/TopDirections";
import SLAComplianceByExpeditor from "../components/SLAComplianceByExpeditor";
import OrderCompletionPieChart from "../components/OrderCompletionPieChart";
import ExpeditorActivityChart from "../components/ExpeditorActivityChart";
import SLAComplianceByDriver from "../components/SLAComplianceByDriver";
import { useScreenSize } from "../../../hooks/useScreenSize";
import TopDirectionsMobile from "../components/TopDirectionsMobile";
import AnalyticsByClientOrders from "../components/AnalyticsByClientOrders";
import AnalyticsByClientPublicOrders from "../components/AnalyticsByClientPublicOrders";
import CreatedOrdersByEmployee from "../components/CreatedOrdersByEmployee";
import AppointmentMethodShare from "../components/AppointmentMethodShare";
import EmployeeOrdersByExpeditor from "../components/EmployeeOrdersByExpeditor";
import TopDirectionsTable from "../components/TopDirectionsTable";
import VehicleMarkStats from "../components/VehicleMarkStats";
import VehicleDistanceStats from "../components/VehicleDistanceStats";
import ParticipationInTendersChart from "../components/ParticipationInTendersChart";
import {
  transformCompareOrderPrice,
  transformDateData,
  transformMonthlyOrderIndicators,
} from "../../../utils/mapDataTransformers";
import OrderCountByPeriodExpeditor from "../components/OrderCountByPeriodExpeditor";
import AnalyticsByCompareOrderPrice from "../components/AnalyticsByCompareOrderPrice";

const AnalyticsTransportExpeditor = ({ user }) => {
  const { t } = useTranslation();
  const { isMobileView } = useScreenSize();

  const [baseMetricDateStart, setBaseMetricDateStart] = useState(moment().subtract(30, "days").toDate());
  const [baseMetricDateEnd, setBaseMetricDateEnd] = useState(new Date());
  const [currency, setCurrency] = useState("");

  const [baseMetric, setBaseMetric] = useState();
  const [topDirections, setTopDirections] = useState([]);
  const [SLAComplianceExpeditor, setSLAComplianceExpeditor] = useState([]);
  const [expeditorActivity, setExpeditorActivity] = useState([]);
  const [ontimeExpeditorOrdersCount, setOntimeExpeditorOrdersCount] = useState([]);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [publicOrders, setPublicOrders] = useState([]);
  const [employeeOrders, setEmployeeOrders] = useState([]);
  const [appointmentShareData, setAppointmentShareData] = useState([]);
  const [employeeOrdersByExpeditor, setEmployeeOrdersByExpeditor] = useState([]);

  /// new
  const [vehicleMarkStats, setVehicleMarkStats] = useState([]);
  const [tenderStats, setTenderStats] = useState([]);
  const [turnover, setTurnover] = useState([]);
  const [monthlyOrderIndicators, setMonthlyOrderIndicators] = useState([]);
  const [top10DirectionsTable, setTop10DirectionsTable] = useState([]);
  const [transportationCount, setTransportationCount] = useState([]);
  const [SLACompliance, setSLACompliance] = useState([]);
  const [chartСompareOrderPrice, setChartСompareOrderPrice] = useState([]);

  const [baseMetricIsCompleted, setBaseMetricIsCompleted] = useState(true);
  const [topDirectionsIsCompleted, setTopDirectionsSatatusIsCompleted] = useState(true);
  const [turnoverIsCompleted, setTurnoverIsCompleted] = useState(true);
  const [top10DirectionsTableIsCompleted, setTop10DirectionsTableIsCompleted] = useState(true);

  const startDate = useMemo(() => moment(baseMetricDateStart).format("YYYY-MM-DD"), [baseMetricDateStart]);
  const endDate = useMemo(() => moment(baseMetricDateEnd).format("YYYY-MM-DD"), [baseMetricDateEnd]);

  const transformedMonthlyOrderIndicators = useMemo(() => {
    return transformMonthlyOrderIndicators(monthlyOrderIndicators);
  }, [monthlyOrderIndicators]);
  const transformedCompareOrderPriceData = useMemo(() => {
    return transformCompareOrderPrice(chartСompareOrderPrice);
  }, [chartСompareOrderPrice]);
  const transformedTurnoverData = useMemo(() => {
    return transformDateData(turnover);
  }, [turnover]);

  const fetchAnalyticsData = async (apiFunc, setter, ...extraArgs) => {
    try {
      const currencyParam = currency === "all" || currency === "" ? "" : currency;
      const response = await apiFunc(startDate, endDate, currencyParam, ...extraArgs);
      setter(response.data);
    } catch (error) {
      console.error(`Error while getting:`, error);
    }
  };

  useEffect(() => {
    fetchAnalyticsData(Analytics.getOrderIndicatorsExpeditor, setBaseMetric, baseMetricIsCompleted);
    fetchAnalyticsData(Analytics.getVehicleMarkStats, setVehicleMarkStats);
    fetchAnalyticsData(Analytics.getTopDirectionsExpeditor, setTopDirections, topDirectionsIsCompleted);
    fetchAnalyticsData(Analytics.getParticipationInTenders, setTenderStats);
    fetchAnalyticsData(Analytics.getTurnoverExpeditor, setTurnover, turnoverIsCompleted);
    fetchAnalyticsData(Analytics.compareOrderPriceIndicatorsExpeditor, setChartСompareOrderPrice);
    fetchAnalyticsData(Analytics.getMonthlyOrderIndicatorsExpeditor, setMonthlyOrderIndicators);
    fetchAnalyticsData(Analytics.getTop10RoutesExpeditor, setTop10DirectionsTable, top10DirectionsTableIsCompleted);
    fetchAnalyticsData(Analytics.getCountOfTransportation, setTransportationCount);
    fetchAnalyticsData(Analytics.getClientEmployeesCreatedOrdersExpeditor, setEmployeeOrders);
    fetchAnalyticsData(Analytics.getExecutionOrdersOnTime, setSLACompliance);

    ///old
    fetchAnalyticsData(Analytics.getExpeditorActivity, setExpeditorActivity);
    fetchAnalyticsData(Analytics.getClientCreatedCompletedOrders, setCompletedOrders);
    fetchAnalyticsData(Analytics.getClientCreatedPublicOrders, setPublicOrders);
    fetchAnalyticsData(Analytics.getClientEmployeeAppointmentShareByMethod, setAppointmentShareData);
    fetchAnalyticsData(Analytics.getEmployeeOrdersByExpeditor, setEmployeeOrdersByExpeditor);
    fetchAnalyticsData(Analytics.getSLAComplianceExpeditor, setSLAComplianceExpeditor);
    fetchAnalyticsData(Analytics.getOntimeExpeditorOrdersCount, setOntimeExpeditorOrdersCount);
  }, [startDate, endDate, currency]);

  useEffect(() => {
    fetchAnalyticsData(Analytics.getTopDirectionsExpeditor, setTopDirections, topDirectionsIsCompleted);
  }, [topDirectionsIsCompleted]);

  useEffect(() => {
    fetchAnalyticsData(Analytics.getTurnoverExpeditor, setTurnover, turnoverIsCompleted);
  }, [turnoverIsCompleted]);

  useEffect(() => {
    fetchAnalyticsData(
      Analytics.getTop10RoutesExpeditor, setTop10DirectionsTable, top10DirectionsTableIsCompleted);
  }, [top10DirectionsTableIsCompleted]);

  return (
    <div className={style.wrapperAnalytics}>
      <BasicAnalytics
        startDate={baseMetricDateStart}
        setStartDate={setBaseMetricDateStart}
        endDate={baseMetricDateEnd}
        setEndtDate={setBaseMetricDateEnd}
        item={baseMetric}
        currency={currency}
        setCurrency={setCurrency}
        isExpeditor
      />

      <div className={style.metric}>
        <AnalyticsByCompareOrderPrice item={transformedCompareOrderPriceData} currency={currency} />
        <OrderCountByPeriodExpeditor item={transportationCount} />
      </div>

      <div className={style.metric}>
        <VehicleMarkStats item={vehicleMarkStats} />
        <VehicleDistanceStats item={vehicleMarkStats} />
      </div>

      <div className={style.metric}>
        {isMobileView ? (
          <TopDirectionsMobile
            item={topDirections}
            isExpeditor
            isCompleted={topDirectionsIsCompleted}
            setIsCompleted={setTopDirectionsSatatusIsCompleted}
          />
        ) : (
          <TopDirections
            item={topDirections}
            isExpeditor
            isCompleted={topDirectionsIsCompleted}
            setIsCompleted={setTopDirectionsSatatusIsCompleted}
          />
        )}
        <ParticipationInTendersChart item={tenderStats} />
      </div>

      <div className={style.metric}>
        <OrderCountByPeriod
          item={transformedTurnoverData}
          isExpeditor
          isCompleted={turnoverIsCompleted}
          setIsCompleted={setTurnoverIsCompleted}
          currency={currency}
        />
        <AnalyticsByTransportType item={transformedMonthlyOrderIndicators} />
      </div>

      <div className={style.metric}>
        {/* <SLAComplianceByExpeditor item={SLACompliance} /> */}
        <CreatedOrdersByEmployee item={employeeOrders} />
      </div>

      <TopDirectionsTable
        top10DirectionsTable={top10DirectionsTable}
        isExpeditor
        isCompleted={top10DirectionsTableIsCompleted}
        setIsCompleted={setTop10DirectionsTableIsCompleted}
        currency={currency}
      />

      {/* old */}
      {/* <div className={style.metric}>
        <AnalyticsByClientOrders item={completedOrders} />
      </div> */}

      <div className={style.metric}>
        {/* <AnalyticsByClientPublicOrders item={publicOrders} /> */}
        <EmployeeOrdersByExpeditor item={employeeOrdersByExpeditor} />
      </div>

      {/* <div className={style.metric}>
        <ExpeditorActivityChart item={expeditorActivity} />
        <AppointmentMethodShare item={appointmentShareData} />
      </div> */}

      <div className={style.metric}>
        <SLAComplianceByDriver item={SLAComplianceExpeditor} />
        <OrderCompletionPieChart item={ontimeExpeditorOrdersCount} />
      </div>
    </div>
  );
};

export default AnalyticsTransportExpeditor;
